<div class="d-flex flex-row flex-wrap justify-content-end mb-4">
  <app-primary-btn [label]="'Add Transporter'" (action)="openTransporterModal()" />
</div>

@if (isDataLoading) {
  <app-loading-spinner [message]="'Loading transporters...'" />
} @else {
  @if (transporters && !transporters.length) {
    <app-info-alert>{{ NO_TRANSPORTERS_ALERT_MSG }}</app-info-alert>
  } @else {
    <div class="table-responsive">
      <table class="table table-hover align-middle">
        <thead class="text-muted">
          <tr>
            <th>#</th>
            <th>Full Name</th>
            <th class="text-end">Vehicle Number</th>
            <th class="text-end">Vehicle Type</th>
            <th class="text-end">Phone</th>
            <th class="text-end">Email</th>
            <th class="text-end">Address</th>
            <th class="text-center">Action</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let transporter of transporters; let i = index" class="cursor-pointer">
            <td>{{ rowNumber(i) }}</td>
            <td>{{ (transporter.first_name + ' ' + transporter.last_name).trim() || '-' }}</td>
            <td class="text-end">{{ transporter.vehicle_number || '-' }}</td>
            <td class="text-end">{{ transporter.vehicle_type || '-' }}</td>
            <td class="text-end">{{ transporter.phone_number || '-' }}</td>
            <td class="text-end">{{ transporter.email || '-' }}</td>
            <td class="text-end">{{ transporter.address_line1 || '-' }}</td>
            <td class="text-center" (click)="$event.stopPropagation()">
              <div class="d-flex flex-row gap-2 justify-content-center">
                <button class="btn btn-action-edit" (click)="openTransporterModal(transporter)" title="Edit">
                  <i class="bi bi-pencil"></i>
                </button>
                <button class="btn btn-action-delete" (click)="onRemoveTransporter(transporter.id)" title="Delete">
                  <i class="bi bi-trash"></i>
                </button>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  }

  <app-pagination
    [currentPage]="currentPage"
    [totalCount]="totalCount"
    [pageSize]="pageSize"
    [hasNextPage]="hasNextPage"
    [hasPreviousPage]="hasPreviousPage"
    (pageChange)="onPageChange($event)" />
}

<ng-template #transporterModal let-modal>
  <div class="modal-header">
    <h5 class="modal-title">
      {{ selectedTransporter ? 'Edit Transporter' : 'Add Transporter' }}
    </h5>
    <button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss()"></button>
  </div>

  <form [formGroup]="transporterForm" (ngSubmit)="onSaveTransporter(modal)">
    <div class="modal-body">
      <div class="row g-3">
        <div class="col-md-6">
          <label class="form-label">First Name</label>
          <input type="text" class="form-control" formControlName="first_name" />
        </div>

        <div class="col-md-6">
          <label class="form-label">Last Name</label>
          <input type="text" class="form-control" formControlName="last_name" />
        </div>

        <div class="col-md-6">
          <label class="form-label">Vehicle Number</label>
          <input type="text" class="form-control" formControlName="vehicle_number" />
        </div>

        <div class="col-md-6">
          <label class="form-label">Vehicle Type</label>
          <input type="text" class="form-control" formControlName="vehicle_type" />
        </div>

        <div class="col-md-6">
          <label class="form-label">Phone Number</label>
          <input type="text" class="form-control" formControlName="phone_number" />
        </div>

        <div class="col-md-6">
          <label class="form-label">Email</label>
          <input type="email" class="form-control" formControlName="email" />
        </div>

        <div class="col-md-6">
          <label class="form-label">Address Line 1</label>
          <input type="text" class="form-control" formControlName="address_line1" />
        </div>

        <div class="col-md-6">
          <label class="form-label">Address Line 2</label>
          <input type="text" class="form-control" formControlName="address_line2" />
        </div>
      </div>
    </div>

    <div class="modal-footer">
      <button type="button" class="btn btn-secondary" (click)="modal.dismiss()">Cancel</button>
      <button type="submit" class="btn btn-primary" [disabled]="transporterForm.invalid">
        @if (isDataSaving) {
          <app-loading-spinner [inline]="true" class="me-2"></app-loading-spinner>
        }
        {{ selectedTransporter ? 'Update' : 'Create' }}
      </button>
    </div>
  </form>
</ng-template>
